import { loadTimezoneFinder } from './loadTimezoneFinder';
import { isValidCoordinates, isValidTimezone } from './timezones';

export const TIMEZONE_LOOKUP_ERROR =
  'Could not load timezone data. Reload the page or retry the lookup.';

const getTimezone = async (
  latitude: number,
  longitude: number,
): Promise<{ id: string }> => {
  if (!isValidCoordinates(latitude, longitude)) {
    throw new Error(
      'Enter valid school coordinates before checking the timezone.',
    );
  }
  const finder = await loadTimezoneFinder().catch(() => {
    throw new Error(TIMEZONE_LOOKUP_ERROR);
  });
  // The geographic library takes longitude first. Never guess at a boundary
  // with multiple zones or fall back to a default when no zone is found.
  const zones: unknown[] = finder.get_tz_names(longitude, latitude);
  if (zones.length !== 1 || !isValidTimezone(zones[0])) {
    throw new Error(
      'Could not determine a single timezone for this location. Check the school coordinates.',
    );
  }
  return { id: zones[0] };
};

export default getTimezone;
